// extracted by mini-css-extract-plugin
module.exports = {"square":"ParameterGraph_square__347al","stockingName":"ParameterGraph_stockingName__HbR38"};